import React from "react";
import { Link } from "react-router-dom";
import { LogOut } from "lucide-react";
import { LanguageToggle } from "@/components/LanguageToggle";
import { PUBLIC_NAV } from "./PublicHeader";

export function MobileDrawer({ user, locPath, onLogout, t }) {
  return (
    <div className="md:hidden border-t border-[color:var(--bk-line)] bg-[color:var(--bk-ivory)]" data-testid="pub-mobile-menu">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex flex-col gap-1 text-[color:var(--bk-navy)]">
        {PUBLIC_NAV.map((n) => (
          <Link key={n.key} to={n.to}
            className={`rounded-md px-3 py-2 text-sm ${locPath === n.to ? "bg-[color:var(--bk-navy)] text-white" : "hover:bg-[color:var(--bk-ivory-2)]"}`}
            data-testid={`pub-mob-${n.key}`}>
            {t(n.key)}
          </Link>
        ))}
        <div className="mt-3 pt-3 border-t border-[color:var(--bk-line)] flex items-center justify-between gap-2">
          <LanguageToggle testId="language-toggle-mobile" />
          {!user ? (
            <div className="flex gap-2">
              <Link to="/login" className="rounded-full border border-[color:var(--bk-navy)]/20 px-4 py-2 text-xs font-semibold">{t("login")}</Link>
              <Link to="/register" className="btn-primary !py-2 !px-4 !text-xs">{t("register")}</Link>
            </div>
          ) : (
            <div className="flex gap-2">
              <Link to="/dashboard" className="rounded-full border border-[color:var(--bk-navy)]/20 px-4 py-2 text-xs font-semibold">{t("dashboard")}</Link>
              <button onClick={onLogout} data-testid="pub-mob-logout-btn" className="inline-flex items-center gap-1.5 rounded-full bg-[color:var(--bk-navy)] text-white px-4 py-2 text-xs font-semibold">
                <LogOut className="w-3.5 h-3.5" /> {t("logout")}
              </button>
            </div>
          )}
        </div>
      </nav>
    </div>
  );
}
